import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  boxStack: {
    position: 'relative',
    userSelect: 'none',
    transition: `height ${theme.speed.normal}ms`,
  },
  child: {
    width: '100%',
    position: 'absolute',
    overflow: 'hidden',
    transformOrigin: 'bottom center',
    transition: `bottom ${theme.speed.normal}ms, transform ${theme.speed.normal}ms, height ${theme.speed.normal}ms`,
  },
  bottomBoxInner: {
    transition: `opacity ${theme.speed.normal}ms`,
    height: '100%',
  },
}));

export default useStyle;
